import React from 'react';
import {Route} from 'react-router-dom';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';
import AsyncPage from './async';

export default (
  <Route key="/consumer/features/ai-photo-fixer" element={<DefaultConsumerLayout />}>
    <Route path="consumer/features/ai-photo-fixer" element={<AsyncPage />} />
  </Route>
);
